<template>
  <div class="modal-container">
    <div class="add-box clearfix">
      <table-header
          @add="insertEvent"
          @remove="removeEvent"
          @copy="paste"
          :txt="'结算日期以实际确认时间为准（滞期结算日期同滞期费开票日期）'"
      ></table-header>
      <vxe-table
          border
          show-overflow
          show-footer
          ref="xTable"
          class="table-style"
          max-height="450"
          :auto-resize="true"
          :data="tableData"
          :edit-rules="formRules"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          @scroll="clearV"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column title="结算类型" field="paymentType" v-if="orderVersion !== 4">
          <template v-slot:header>
            <span style="color: red">*</span>结算类型
          </template>
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.paymentType"
                placeholder="请选择"
                @blur="clearTableV"
                transfer
                d
            >
              <vxe-option value="1" label="托运人结算"></vxe-option>
              <vxe-option value="2" label="承运人结算"></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="paymentTime" title="结算时间">
          <template v-slot:header>
            <span style="color: red">*</span>结算时间
          </template>
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.paymentTime"
                placeholder="选择日期"
                type="date"
                transfer
                @blur="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="amount" title="结算金额">
          <template v-slot:header>
            <span style="color: red">*</span>结算金额
          </template>
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.amount"
                placeholder="必填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="note" title="摘要">
          <template v-slot:header>
            <span style="color: red">*</span>摘要
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.note" placeholder="选填" v-if="orderVersion === 4"></vxe-input>
              <vxe-select v-model="row.note" :options="noteList" transfer v-if="orderVersion !== 4"></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="remark" title="备注">
          <template v-slot="{ row }">
            <vxe-input v-model="row.remark" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="fileList" title="上传附件">
          <template v-slot="{ row }">
            <upload-list
                :row="row"
                :initFileList="row.fileList"
                :view="'packup'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button type="primary" @click="save">提 交</Button>
    </div>

  </div>
</template>

<script>
import $C from "@/consts";
import ChooseOrder from "@/components/modal/ChooseRelationOrder";
import ChooseCarShip from "@/components/modal/ChooseCarShip";
import $api from "@/apiProvider";
import XLSX from "xlsx";
import Message from "@/components/common/Message";
import {
  getExcelTime,
  showLoading,
  hideLoading,
  isEmpty,
  isNotEmpty
} from "@/utils/util";
import UploadList from "@/components/common/UploadList";
import TableHeader from "../../common/TableHeader";
import PlatformCorp from "@/components/common/PlatformCorp";
import moment from "moment";
import {timeFormatDate} from "@/filters/time";


export default {
  props: ["orderId", "endTime","orderVersion"],
  components: {
    UploadList,
    TableHeader,
  },
  data() {
    return {
      formRules: {
        amount: [{required: true, message: "请结算金额"}],
        paymentType: [{required: true, message: "请选择结算类型"}],
        paymentTime: [{required: true, message: "请选择时间"}],
        note: [{required: true, message: "请选择摘要"}],
      },
      records: [],
      tableData: [
        {
          no: 1,
          amount: null, //起运地
          paymentType: null, //起运时间
          paymentTime: null, //车船号
          note: null, //备注
          fileList: [],
          fileUuidList: [],
        }
      ],
      noteList: []
    };
  },
  mounted() {
    this.getDictByCodeP(58000);
  },
  methods: {
    async getDictByCodeP(code) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let data = res.data;
        let arr = [];
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictText,
          })
        })
        this.noteList = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    selectChangeEvent({checked, row}) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({checked, records}) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    async validEvent() {
      let errMap = await this.$refs.xTable.validate().catch(errMap => errMap);
      return errMap ? false : true;
    },
    paste() {
      let records = this.records.sort((a, b) => a.no - b.no);
      if (records.length > 0) {
        records.map(i => {
          let record = Object.assign({}, i);
          record.no = this.$refs.xTable.data.length + 1;
          this.pushIntoTable(record);
        });
      } else {
        this.$XModal.message({
          status: "error",
          message: "请选择需要复制的信息！"
        });
      }
    },
    pushIntoTable(record) {
      let {row: newRow} = this.$refs.xTable.insertAt(record, -1);
      this.$refs.xTable.data.push(record);
    },
    timePartRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var y = 1900 + timeB.getYear();
        var m = "0" + (timeB.getMonth() + 1);
        var d = "0" + timeB.getDate();

        return (
            y +
            "-" +
            m.substring(m.length - 2, m.length) +
            "-" +
            d.substring(d.length - 2, d.length)
        );
      } else {
        return null;
      }
    },
    insertEvent() {
      let record = {
        no: this.$refs.xTable.data.length + 1,
        amount: null, //起运地
        paymentType: null, //起运时间
        paymentTime: null,
        note: null, //备注
        fileList: [],
        fileUuidList: [],
      };
      this.pushIntoTable(record);
    },
    clearTableV() {
      this.$refs.xTable.clearValidate();
    },
    removeEvent() {
      let records = this.records;
      if (records.length > 0) {
        if (this.$refs.xTable.tableData.length > 1) {
          this.$XModal.confirm("您确定要删除选中数据?").then(type => {
            if (type === "confirm") {
              this.clearV();
              records.map(i => {
                this.$refs.xTable.remove(i);
                let key = this.$refs.xTable.data.indexOf(i);
                this.$refs.xTable.data.splice(key, 1);
              });
              this.records = [];
              if (this.isExport === false) {
                this.$refs.xTable.data.map((j, index) => {
                  j.no = index + 1;
                });
              }
            }
          });
        } else {
          this.$XModal.alert({
            message: "已经是最后一条了！",
            status: "warning"
          });
        }
      } else {
        this.$XModal.message({
          status: "error",
          message: "请选择需要删除的信息！"
        });
      }
    },
    clearV() {
      this.$refs.xTable.clearValidate();
    },
    async save() {
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return;
      }
      // let isCanNotSubmit = false;
      let arr = JSON.parse(JSON.stringify(this.tableData));
      arr.map(i => {
        if (i.paymentTime) {
          var date = i.paymentTime
          date = date.replace(/-/g, '/');
          var timestamp = new Date(date).getTime();
          i.paymentTime = timestamp
        }
        if (this.orderVersion === 4){
          i.paymentType = 2;
        }
        i.id = parseInt(this.orderId)
        if (i.fileNewList) {
          i.fileNewList.forEach(item => {
            item.response.data.sourceType = 1
            i.fileList.push(item.response.data)
          })
        }
      });
      showLoading();
      let url = "batchCreate";
      if (this.orderVersion === 4) {
        url = "batchCreateOrdersAttachedSettlement";
      }
      let res = await $api.twoSettlement.request(url, arr);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("提交成功");
        this.close();
        this.$emit("createCommit", false);
      } else {
        let data = res.data;
        let message = "";
        if (data !== undefined && data.length > 0) {
          data.map(i => {
            message =
                message +
                "序号" +
                this.tableData[i.failArrayIndex].no +
                "，" +
                i.failMsg +
                "\n";
          });
          let errorData = [];
          res.data.forEach(failItem => {
            errorData.push(
                Object.assign({}, this.tableData[failItem.failArrayIndex])
            );
          });
          this.tableData = errorData;
        }
        if (message === "") {
          this.$XModal.alert({
            message: "接口异常",
            status: "error"
          });
        } else {
          this.$refs.messageModal.setMessage(message);
          this.messageVisible = true;
        }
      }
    },
    close() {
      this.tableData = [
        {
          no: 1,
          amount: null, //起运地
          paymentType: null, //起运时间
          paymentTime: null,
          note: null, //备注
          fileList: [],
          fileUuidList: [],
          id: null
        }
      ];
      this.clearV();
      this.records = [];
    },

  }
};
</script>

<style>
.modal-container {
  position: relative;
  height: 100%;
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.add-btn {
  width: 20px;
  height: 20px;
  color: #fff;
  line-height: 20px;
  background-color: #2d8cf0;
  border: none;
  border-radius: 0;
}
</style>